import { Title } from '@/components/commons/typography/Title'
import { ButtonComponent } from '@/components/commons'
import { TextArea } from '@/components/commons/forms/TextArea.component'
import { useState } from 'react'
import { useProfileById } from 'containers/profile/hooks/useProfile'
import { Avatar } from 'containers/recommendations/Avatar'
import { Modal } from '@/components/modal/Modal'

interface RequestConnectionButtonProps {
  isOpen: boolean
  onClose?: () => void
  onRequestConnection?: (message?: string) => void
  disabled?: boolean
  profileId: string
}
export const ModalRequestConnection = ({
  isOpen,
  onClose,
  onRequestConnection,
  disabled,
  profileId,
}: RequestConnectionButtonProps) => {
  const [message, setMessage] = useState('')

  const { profile } = useProfileById(profileId)

  return (
    <Modal opened={isOpen} onClose={onClose} size="xl">
      <div className="flex flex-column items-center gap-10 px-14 pb-20">
        <Avatar
          image={profile?.avatar}
          alt={`${profile?.username}_connection_avatar`}
          size={120}
        />
        <Title
          sizeClass="text-18"
          weightClass="font-bold"
          className="text-center"
          lineHeightClass="leading-28"
        >
          {`Customize your connection`}
          <br />
          {`request to ${profile?.firstName || 'this user'}`}
        </Title>
        <p className="text-16 text-center font-regular leading-28 m-0 text-secondary">
          {'You can add a message to personalize'}
          <br />
          {'your connection request.'}
        </p>

        <TextArea
          usePlaceholder
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Ex: Hi! I wanted to connect with you about this great project idea that we could collaborate on..."
        />
        <div className="flex items-center justify-flex-end gap-12 pt-24">
          <ButtonComponent
            size="small"
            variation="secondary"
            label="Cancel"
            onClick={onClose}
            loading={disabled}
            disabled={disabled}
          />
          <ButtonComponent
            size="small"
            label="Connect"
            loading={disabled}
            disabled={disabled}
            onClick={() => onRequestConnection && onRequestConnection(message)}
          />
        </div>
      </div>
    </Modal>
  )
}
